import { Link } from "react-router-dom";
import { SocialIcon } from "react-social-icons";

function Footer() {
  return (
    <section id="footer">
      <div class="container mx-auto">
        <hr class="h-px my-8 xlg:mx-50 lg:mx-40 md:mx-28 sm:mx-6 " />
        <div class="space-y-8">
          <div class="flex space-x-3 mx-auto justify-evenly xlg:justify-start xlg:ml-64 text-sm">
            <div class="space-y-3">
              <h1 class="font-medium ">Call</h1>
              <p class=" text-gray-500 dark:text-gray-400">+265992970373</p>
            </div>
            <div class="space-y-3">
              <h1 class="font-medium">Email</h1>
              <p class="text-gray-500 dark:text-gray-400">
                sangwanikondowe7@gmail.com
              </p>
            </div>
          </div>

          <div class=" pb-10 md:mx-24 lg:mx-36 flex xlg:mx-60 justify-between">
            <div class=" text-gray-500 dark:text-gray-400 ml-5">
              Innovating One Project At a Time
            </div>

            <div class="hidden md:flex space-x-6 justify-end">
              <SocialIcon
                url="https://github.com/sangwaniKondowe"
                target="_blank"
                fgColor="#fff"
                class="transform hover:scale-110 transition ease-out duration-300"
                style={{ height: 30, width: 30 }}
              />
              <SocialIcon
                url="https://linkedin.com/in/sangwani-kondowe-624408200"
                target="_blank"
                fgColor="#fff"
                class="transform hover:scale-110 transition ease-out duration-300"
                style={{ height: 30, width: 30 }}
              />
              <SocialIcon
                url="https://twitter.com/SangwaniKondowe"
                target="_blank"
                fgColor="#fff"
                class="transform hover:scale-110 transition ease-out duration-300"
                style={{ height: 30, width: 30 }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Footer;
